import {action, computed, observable} from 'mobx';
import {endpoints, api, types} from 'shared/core';
import {DomainStore} from 'shared/store';
import _ from 'lodash';
import {CompanyFile} from 'stores/company_files';

class CompanyFileListState {
  store = new DomainStore();

  @observable errors = {};
  @observable companyFiles = [];
  @observable newCompanyFile;
  @observable reorderingFiles;
  @observable editCompanyFileModalOpen = false;
  @observable reorderFilesModalOpen = false;

  @action async load() {
    await this.store._compose([
      endpoints.COMPANY_FILES.ALL
    ]);

    this.companyFiles = this.store._getAll(types.COMPANY_FILE, CompanyFile);
  }

  @action openReorderFilesModal() {
    this.reorderingFiles = this.companyFiles.map(file => new CompanyFile(file));
    this.reorderFilesModalOpen = true;
  }

  @action closeReorderFilesModal() {
    this.reorderFilesModalOpen = false;
  }

  @action openEditCompanyFileModal(companyFile) {
    this.newCompanyFile = new CompanyFile(companyFile);
    this.editCompanyFileModalOpen = true;
  }

  @action closeEditCompanyFileModal() {
    this.editCompanyFileModalOpen = false;
    this.errors = {};
  }

  @action async deleteCompanyFile(companyFile) {
    await this.store.destroy(companyFile);
    await this.load();
  }

  @action async saveFileOrders() {
    const fileParams = {};
    this.reorderingFiles.forEach(file => fileParams[file['id']] = file['order']);

    await api.patch(endpoints.COMPANY_FILES.REORDER, {'company_files': fileParams});

    await this.load();
    this.closeReorderFilesModal();
  }

  @action async saveCompanyFile() {
    const {model, errors} = this.newCompanyFile.isNew ?
      await this.store.post(endpoints.COMPANY_FILES.ALL, types.COMPANY_FILE, this.newCompanyFile) :
      await this.store.patch(this.newCompanyFile);
    if(model){
      this.closeEditCompanyFileModal();
      await this.load();
    }
    this.errors = errors;
  }

  @action removeFile() {
    this.newCompanyFile.file = null;
  }

  @action mergeFile(file) {
    this.newCompanyFile.merge({file: file});
  }

  @action updateFile(files) {
    const file = _.head(files);
    file ? this.mergeFile(file) : this.removeFile();
  }

  @computed get sortedCompanyFiles(){
    return _.sortBy(this.companyFiles, 'order');
  }
}

export default CompanyFileListState;
